export default __webpack_public_path__ + "static/InterDisplay-MediumItalic-d37fcfbb7ec9352dab630ed260ee20a4.woff";